export default "__VITE_ASSET__BLm0kshN__";